import React from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
// 样式
import style from './DownLoadApp.module.scss'
import qrCodeImg from './images/download-qrcode.png'

// 跳转应用宝下载页
export const goToDownload = () => {
  window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=ubox.app&fromcase=40003'
}

const DownLoadApp = (props) => {
  const { isFixed, children } = props

  return <div styleName={classNames({
            'wrap': true,
            'fixed': isFixed,
          })}>
          <div styleName="box">
            {
              children ? <div onClick={goToDownload}>{children}</div> : <div styleName="contain">
                <div styleName="pic">
                  <img alt="下载二维码"
                      src={qrCodeImg}/>
                </div>
                <div className="others">
                  <div styleName="hint">
                    <span styleName="arrows"></span>
                    <span styleName="text">长按识别二维码下载</span>
                  </div>
                  <div onClick={goToDownload}
                      styleName="btn">点击下载APP</div>
                </div>
              </div>
            }
          </div>
        </div>
}

export default CSSModules(DownLoadApp, style, { allowMultiple: true })